<template>
<div style='text-align:center; height:100%'>
<div style='display:inline-block; text-align:left; max-width:1024px; width:100%; height:100%;'>
<div style='min-height:calc(100% - 72px)' id='pageContainer'>
<b-navbar class="navbar-toggleable-sm" type="inverse" variant="success" id="mainMenu">
  <b-nav-toggle target="nav_collapse"></b-nav-toggle>
  <span class="navbar-brand">Mexmat-disk</span>
  <b-collapse is-nav id="nav_collapse">
    <div id='toolbar-container' style='text-align:center'>
    <div class='toolbar' id='toolbar' >
      <b-popover :triggers="['hover']" placement="bottom" content="Удалить выделенные">
        <b-btn variant="primary" @click='deleteFiles'><img src="./../assets/delete.png"></b-btn>
      </b-popover>
      <b-popover :triggers="['hover']" placement="bottom" content="Скачать выделенные">
        <b-btn variant="primary" @click='download(null)'><img src="./../assets/download.png"></b-btn>
      </b-popover>
      <b-popover :triggers="['hover']" placement="bottom" content="Загрузить на сервер">
        <b-btn variant="primary" @click="chooseFileToUpload"><div id='uploadButtonSpan'><span v-if='isFileUploading' id="uploadProgress"></span></div></b-btn>
      </b-popover>
      <form id='uploadFileForm' style="display:inline-block; width:0px; height:0px; overflow:hidden">
        <input type="file" id="uploadFile" name="uploadFile" multiple v-on:change='startUpload'/>
      </form>
      <b-popover :triggers="['hover']" placement="bottom" content="Создать папку">
        <b-btn variant="primary" @click="$refs.folderNameDialog.show()" v-b-modal.modal-prevent-closing><img src="./../assets/createFolder.png"></b-btn>
      </b-popover>
    </div>
    </div>
    <b-nav is-nav-bar class="ml-auto">
      <b-nav-item v-if="authType!=='teacher'" @click="$refs.changePassRef.show()">Сменить пароль</b-nav-item>
      <b-nav-item v-if="authType=='teacher'" @click="$refs.erasePassRef.show()">Сбросить пароль школьнику</b-nav-item>
      <b-nav-item @click="$refs.contactSupportRef.show()">Поддержка</b-nav-item>
      <b-nav-item @click="logout()">Выйти</b-nav-item>
    </b-nav>
  </b-collapse>
</b-navbar>

<!-- <div class="dropzone-area">
    <div class="dropzone-text">
        <span class="dropzone-title">Drop image here or click to select</span>
    </div>
    <input id='dropUploadFileForm' type="file" @change="dropUpload" multiple>
</div> -->

<div class="main-page-content">
  <div class='alertsBlock'>
    <b-alert :show="showAlert" variant="danger" @dismissed="showAlert=1">  {{ alertText }}  </b-alert>
    <b-alert :show="showMessage" variant="success" @dismissed="showMessage=1">  {{ messageText }}  </b-alert>
  </div>

  
  <b-modal id="confirmDialog" ref="confirmDialogRef" :title="confirm.title" :okTitle="confirm.okTitle" :closeTitle="confirm.closeTitle" :ok2Title="confirm.ok2Title" @ok="confirm.actionOk">
    {{ confirm.message }}
  </b-modal>
  
  
  <Dialogue v-if="showCreateFolderDialog" @close="showCreateFolderDialog = false" v-bind:dialog-type="dialogType" v-bind:template-name="templateName" v-bind:web-socket="webSocket" v-bind:current-folder="currentFolder"> </Dialogue>
  <b-modal id="folderNameDialog" ref="folderNameDialog" title="Создание папки" okTitle="Создать" closeTitle="Отмена" @ok="createFolder">
    <form @submit.stop.prevent="createFolder">
      <b-form-input type="text" placeholder="Введите имя папки" v-model="newFolderName"></b-form-input>
    </form>
  </b-modal>
  
  
  <Dialogue v-if="showSupportDialog" @close="showSupportDialog = false" v-bind:dialog-type="dialogType" v-bind:template-name="templateName" v-bind:web-socket="webSocket" v-bind:current-folder="currentFolder"> </Dialogue>  
  <b-modal id="contactSupport" ref="contactSupportRef" title="Написать в службу поддержки" okTitle="Отправить" closeTitle="Отмена" @ok="contactSupport">
    <form>
      <b-form-input v-model="contactSupportMessage" placeholder="Напишите свой вопрос. Укажите ваш почтовый адрес для ответа" :textarea="true" :rows="20"></b-form-input>
    </form>
  </b-modal>


  <Dialogue v-if="showPassDialog" @close="showPassDialog = false" v-bind:dialog-type="dialogType" v-bind:template-name="templateName" v-bind:web-socket="webSocket" v-bind:current-folder="currentFolder"> </Dialogue>
  <b-modal id="changePass" ref="changePassRef" title="Смена пароля" okTitle="Сменить" closeTitle="Отмена" :hideFooter='true'>
    <form>
        <b-form-input v-on:keyup.enter="changePass" v-model="password1" type="password" placeholder="Введите новый пароль" style='margin-bottom: 1rem;'></b-form-input><br>
        <b-form-input v-on:keyup.enter="changePass" v-model="password2" type="password" placeholder="Подтвердите пароль" style='margin-bottom: 1rem;' lazy-formatter > </b-form-input>
    </form>
    <footer class="modal-footer">
        <slot name="modal-footer">
            <b-alert :show="password1!=password2 && password2!=''" variant="danger">  Пароли не совпадают  </b-alert>
            <b-btn variant="secondary" @click="$refs.changePassRef.hide(true)">Отмена</b-btn>
            <b-btn variant="primary" @click="changePass">Сменить</b-btn>
        </slot>
    </footer>
  </b-modal>

  <Dialogue v-if="showErasePassDialog" @close="showErasePassDialog = false" v-bind:dialog-type="dialogType" v-bind:template-name="templateName" v-bind:web-socket="webSocket" v-bind:current-folder="currentFolder"> </Dialogue>
  <b-modal id="erasePass" ref="erasePassRef" title="Сбросить пароль" okTitle="Сбросить" closeTitle="Отмена" :hideFooter='true'>
    <form>
        <!-- <div id='body' style='text-align:center; height:100%;'>
        <div style='display:inline-block; text-align:left; max-width:600px; width:100%; height:100%;'>
        <div style='height: calc(100% - 72px); min-height:300px'> -->
        <table style='height:calc(100%);'><tr><td class="align-middle">
          <div class="main-login main-center">
          <div>
            <b-form-select @change.native="loadFIOList()" v-model="selectedGroup" :options="optionsSchoolGroup" class="mb-3" />
            <br>
            <b-form-select v-model="selectedStudentFIOList" :options="FIOList" class="mb-3" :disabled="selectedGroup==null || FIOList.length==1" />
          </div>
          <b-alert v-bind:show="showAlert" state="danger" @dismissed="showAlert=1">  {{ alertText }} </b-alert>
          </div>
        </td></tr></table>
        <!-- </div>
        </div>
        </div> -->
    </form>
    <footer class="modal-footer">
        <slot name="modal-footer">
            <!-- <b-alert :show="selectedGroup!==null && selectedStudentFIOList==null" variant="danger">  Выберите ФИО  </b-alert> -->
            <b-btn variant="secondary" @click="$refs.erasePassRef.hide(true)">Отмена</b-btn>
            <b-btn variant="primary" @click="erasePass" :disabled='selectedStudentFIOList==null || selectedGroup==null' >Сбросить</b-btn>
        </slot>
    </footer>
  </b-modal>

  <div class=breadcrumbs> <b-breadcrumb :items="breadcrumbs" v-on:click="changeDirBreadcrumb" /> </div>

  <div class="files">
    <div>
      <div class="header file">
        <b-form-checkbox v-on:change='selectAll($event)' v-model="selectAllValue"></b-form-checkbox>
        <div style='display:inline-block; width:44px; height:45px; overflow:hidden'><b-button class="btn exitFolderButton" @click='exitFolder()' v-if='currentFolder!==homeFolder'><img src='./../assets/directory-icon1.png'></b-button></div>
        <div v-on:click="sort(files,'names')" class="file-col-name">Имя файла <b-button v-bind:class="'btn' + (whatSort==0 ? ' active' : '')"> <span v-if='sortType[0]!=1'> &blacktriangle; </span><span v-else> &blacktriangledown; </span> </b-button></div>
        <div v-on:click="sort(files,'sizes')" class="file-col-size">Размер  <b-button v-bind:class="'btn' + (whatSort==1 ? ' active' : '')"> <span v-if='sortType[1]!=1'> &blacktriangle; </span><span v-else> &blacktriangledown; </span> </b-button></div>
        <div v-on:click="sort(files,'dates')" class="file-col-date">Дата  <b-button v-bind:class="'btn' + (whatSort==2 ? ' active' : '')"> <span v-if='sortType[2]!=1'> &blacktriangle; </span><span v-else> &blacktriangledown; </span> </b-button></div>
      </div>
    </div>
    <div v-for="file in files" :key="file.id">
      <div class="file" v-bind:class="(file.isDir ? 'directory' : '') + (file.checked ? ' checked' : '')">
        <b-form-checkbox v-model="file.checked"></b-form-checkbox>
        <div class="file-col-name" v-on:dblclick="open(file, true)" v-on:click="file.checked=!file.checked">&nbsp;{{ file.name }}</div>
        <div class="file-col-actions"><span><b-btn variant="primary" @click='download(file.name)'><img src="./../assets/downloadSmall.png"></b-btn></span></div>
        <div class="file-col-size"><span v-if='!file.isDir'>{{ formatMem(file.size, ' ') }}</span></div>
        <div class="file-col-date">{{ file.date }}</div>
      </div>
    </div>
  </div>
</div>

</div>
<footer>
  <img src="./../assets/logo.png"> <a href='http://www.mmcs.sfedu.ru/'>Институт математики механики и компьютерных наук имени И.И.Воровича</a>
</footer>
</div>

<drop id="dragForm" @drop="dropFiles" @dragenter="dragEnter" @dragleave="dragLeave"
  style="background: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  visibility: hidden;
  opacity: 0;
  display: flex;

  align-items: center;">

  <div id="percentDrop"
  style="color: white;
  text-align: center;
  font-size: 2em;
  width: 100%;"></div>

</drop>

</div>
</template>

<script>
import jQuery from 'jquery'
import {getAccountParams, runServiceCommand} from '../lib/utils'
import Vue from 'vue'
import VueDragDrop from 'vue-drag-drop'

Vue.use(VueDragDrop)

export default {
  name: 'MainPage',
  components: {},

  data () {
    return {
      baseURL: '',
      currentFolder: '',
      breadcrumbs: [{text: 'Disk', to: '/'}],
      debug: true,
      currentUserName: '',
      homeFolder: '',
      authType: '',
      studentType: '',
      course: '',
      group: '',
      virtualFolders: [],
      showSupportDialog: false,
      templateName: '',
      dialogType: '',
      showAlert: 0,
      alertText: '',
      showMessage: 0,
      messageText: '',
      files: [],
      virtual: [],
      isFileUploading: false,
      contactSupportMessage: '',
      confirm: { title: 'Confirm action', message: 'Are you sure?', okTitle: 'Yes', closeTitle: 'Cancel', ok2Title: '', actionOk: () => {}, actionOk2: () => {} },
      action: '',
      showPassDialog: false,
      password1: '',
      password2: '',
      whatSort: 0,
      sortType: [1, 1, 1],
      showErasePassDialog: false,
      FIOList: [{value: null, text: 'Фамилия Имя Отчество'}],
      optionsSchoolGroup: [{value: null, text: 'Группа'}],
      selectedGroup: null,
      selectedStudentFIOList: null,
      selectAllValue: false,
      dragFilesQueue: [],
      uploadData: '',
      showCreateFolderDialog: false,
      newFolderName: ''
    }
  },
  created () {
    getAccountParams().then((params) => {
      this.authType = params.userInfo.authType
      this.currentUserName = params.login
      this.homeFolder = params.userInfo.home
      this.course = params.userInfo.course
      this.group = params.userInfo.group
      this.studentType = params.userInfo.studentType
      this.virtualFolders = params.userInfo.virtualFolders
      this.virtualFoldersNames = params.userInfo.virtualFoldersNames
      this.breadcrumbs[0].to = this.homeFolder
      this.setup()
    }).catch((errMessage) => { this.showError(errMessage) })
    jQuery(window).scroll(() => {
      var scroll = jQuery(window).scrollTop()
      var toolbarContainer = jQuery('#pageContainer')
      var toolbarOffset = toolbarContainer.offset().top
      var toolbar = jQuery('#mainMenu')
      if (scroll > toolbarOffset) {
        // toolbarContainer.height(toolbarContainer.height())
        toolbar.addClass('fixed')
        toolbar.outerWidth(toolbarContainer.width())
      }
      else if (scroll <= 0) toolbar.removeClass('fixed')
    })
    jQuery(window).resize(() => { jQuery('#toolbar').width(jQuery('#toolbar-container').width()) })
    for (var i = 1; i <= 65; i++) {
      this.optionsSchoolGroup.push({ value: i, text: i })
    }

    jQuery(window).on('drag dragstart dragover dragenter', (e) => {
      jQuery('#dragForm').css('visibility', '')
    })
  },

  methods: {
    addLog: function (s) { console.log(s) },
    showError: function (mes) {
      if (!(typeof mes === 'string' || mes instanceof String)) mes = JSON.stringify(mes)
      if (mes === '{}') return
      this.alertText = mes
      this.showAlert = 5
      this.addLog(this.alertText)
    },
    showInfo: function (mes) {
      this.messageText = mes
      this.showMessage = 2
    },

    hashCode: function (str) {
      var hash = 0
      var i
      var chr
      if (str.length === 0) return hash
      for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i)
        hash = ((hash << 5) - hash) + chr
        hash |= 0 // Convert to 32bit integer
      }
      return hash
    },

    open: function (file, pushState) {
      if (file.isDir) this.changeDir(file.name, pushState)
    },

    changeDir: function (dirName, pushState) {
      if (pushState) this.selectAllValue = false
      var i = this.virtualFoldersNames.indexOf(dirName)
      if (i >= 0 && this.homeFolder === this.currentFolder) dirName = this.virtualFolders[i]
      if (dirName + '' === '') return
      var d = dirName[0] === '/' ? dirName : this.currentFolder + (this.currentFolder === '/' ? '' : '/') + dirName
      if (d === '/') d = this.virtualFolders[0]
      // console.log('changeDir. dirName=', dirName, 'd=', d, 'this.currentFolder=', this.currentFolder)
      runServiceCommand('cmd=WATCH_NEW_FOLDER&folder=' + encodeURIComponent(d)).then((files) => {
        if (!('stack' in files)) {
          if (pushState) {
            window.history.pushState({currentFolder: d}, '', 'showFolder?' + d)
          }
          this.setFileList(files, d, false)
        }
        else this.showError('Error while call WATCH_NEW_FOLDER: ' + files.message)
      }).catch(e => {
        this.addLog(e)
        if (String(e) === 'доступ запрещен') {
          this.changeDir(this.homeFolder, true)
        }
      })
    },

    changeDirBreadcrumb: function (item) { this.changeDir(item.to, true) },

    getFolderFromURL: function () {
      var p = window.location.href
      var i = p.indexOf('/', 8)
      var j = p.indexOf('?')
      if (i < 0 || j < 0 || p.substring(i + 1, j) !== 'showFolder') {
        window.history.replaceState({}, '', 'showFolder?' + encodeURIComponent(this.homeFolder))
        return this.getFolderFromURL()
      }
      else p = decodeURIComponent(p.substring(j + 1))
      if (p === '') p = this.homeFolder
      return p
    },

    setup: function () {
      window.onpopstate = (e) => {
        if (e.state) this.changeDir(e.state.currentFolder, false)
      }
      var p = this.getFolderFromURL()
      this.changeDir(p, true)
    },

    updateBreadCrumbs: function () {
      var breadcrumbs = [{text: this.currentUserName, to: this.homeFolder}]
      var deleteArr = this.virtualFolders.slice(0)
      deleteArr.push(this.homeFolder)
      var toDel = deleteArr.reverse().find((f) => this.currentFolder.slice(0, f.length) === f)
      if (toDel === undefined) return
      for (var i = 0; i < this.virtualFoldersNames.length; i++) {
        if (toDel === this.virtualFolders[i]) {
          breadcrumbs.push({text: this.virtualFoldersNames[i], to: this.virtualFolders[i]})
        }
      }
      var insidePath = this.currentFolder.slice(toDel.length)
      var parts = insidePath.substring(1).split('/')
      var to = toDel
      if (this.currentFolder.substring(1) !== '') {
        parts.forEach(part => {
          to += '/' + part
          breadcrumbs.push({text: part, to: to})
        })
      }
      breadcrumbs[breadcrumbs.length - 1].active = true
      // this.addLog('breadcrumbs = ' + JSON.stringify(breadcrumbs))
      this.breadcrumbs = breadcrumbs
    },

    setFileList: function (files, d, mergeChecked) {
      if (!('stack' in files)) {
        if (mergeChecked) {
          for (var i = 0; i < this.files.length; i++) {
            for (var j = 0; j < files.length; j++) {
              if (this.files[i].name === files[j].name) {
                files[j].checked = this.files[i].checked
              }
            }
          }
        }
        files.sort((f1, f2) => {
          return (-(f1.isDir > f2.isDir) + (f2.isDir > f1.isDir)) * 100 + (f1.name.toLowerCase() > f2.name.toLowerCase()) - (f2.name.toLowerCase() > f1.name.toLowerCase())
        })
        this.files = files
        this.currentFolder = d
        this.updateBreadCrumbs()
        if (this.currentFolder === this.homeFolder) {
          for (var ii = 0; ii < this.virtualFoldersNames.length; ii++) {
            this.files.unshift({ name: this.virtualFoldersNames[ii], size: 0, date: '', isDir: true, hidden: false, checked: false })
          }
        }
      }
      else {
        this.showError(files.message)
      }
    },

    logout: function () {
      // erase cookie
      var cookies = document.cookie.split(';')
      for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i]
        var eqPos = cookie.indexOf('=')
        var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT'
      }
      window.location = '/login'
    },

    download: function (fileName) {
      var fileNames = []
      if (fileName === null) {
        for (var i = 0; i < this.files.length; i++) {
          if (this.files[i].checked) {
            fileNames.push(this.files[i].name)
          }
        }
        if (fileNames.length === 0) {
          this.showError('Выберите файлы')
          return
        }
      }
      else {
        fileNames.push(fileName)
      }
      var uri = this.baseURL + '/download?folder=' + encodeURIComponent(this.currentFolder) + '&files=' + encodeURIComponent(JSON.stringify(fileNames))
      var link = document.createElement('a')
      // link.download = fileName
      if (fileNames.length > 1) {
        link.download = 'archive.zip'
      }
      else {
        link.download = fileNames[0]
      }
      link.href = uri
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },

    chooseFileToUpload: function () {
      if (this.isFileUploading) {
        this.showError('Подождите, пока закончится загрузка файлов')
        return
      }
      jQuery('#uploadFile').click()
    },

    createFolder: function () {
      // console.log('createFolder. this.currentFolder=', this.currentFolder, 'this.newFolderName=', this.newFolderName)
      if (this.newFolderName === '') {
        this.showError('Пустое имя папки')
        return
      }
      this.$refs.folderNameDialog.hide()
      runServiceCommand('cmd=CREATE_FOLDER&folder=' + encodeURIComponent(this.currentFolder + '/' + this.newFolderName)).then((res) => {
        if ('stack' in res) this.showError(res.message)
        else {
          if (res['result'] !== 'OK') this.showError(res['result'])
          else {
            this.changeDir(this.currentFolder, false)
            this.showInfo('Папка ' + this.newFolderName + ' создана')
          }
        }
      }).catch(e => this.showError(e))
    },

    startUpload: function (currentFolder) {
      if (typeof currentFolder === 'object') {
        currentFolder = this.currentFolder
      }

      var formData = new FormData(document.getElementById('uploadFileForm'))
      this.isFileUploading = true
      var addToPath = typeof this.uploadFolder === 'undefined' || this.uploadFolder === '' ? '' : '/' + this.uploadFolder
      // console.log(currentFolder + addToPath)
      jQuery.ajax({
        url: 'upload?folder=' + encodeURIComponent(currentFolder + addToPath),
        type: 'POST',
        xhr: () => {
          var xhr = new window.XMLHttpRequest()
          xhr.upload.addEventListener('progress', (evt) => {
            if (evt.lengthComputable) {
              var percentComplete = evt.loaded / evt.total
              percentComplete = parseInt(percentComplete * 100)
              jQuery('#uploadProgress').html(percentComplete + '%')
            }
          }, false)
          return xhr
        },
        success: (data, textStatus, jqXHR) => {
          this.isFileUploading = false
          if (data !== 'OK') {
            this.showError(data)
            jQuery('#dragForm').css('visibility', 'hidden')
            jQuery('#dragForm').css('opacity', 0)
          }
          else {
            this.changeDir(this.currentFolder, false)
            var uploadData = this.dragFilesQueue.pop()
            if (typeof uploadData !== 'undefined') {
              jQuery('#percentDrop').html('Осталось загрузить ' + this.dragFilesQueue.length + ' файлов')
              this.uploadFolder = uploadData['folder']
              jQuery('#uploadFile').prop('files', uploadData['files'])
              this.startUpload(currentFolder)
            }
            else {
              jQuery('#dragForm').css('visibility', 'hidden')
              jQuery('#dragForm').css('opacity', 0)
            }
          }
        },
        error: (XMLHttpRequest, textStatus, errorThrown) => {
          this.isFileUploading = false
          this.showError('Ошибка при загрузке: ' + errorThrown)
          jQuery('#dragForm').css('visibility', 'hidden')
          jQuery('#dragForm').css('opacity', 0)
        },
        data: formData,
        processData: false,
        contentType: false
      })
    },

    dragEnter: function (data, e) {
      jQuery('#dragForm').css('visibility', '')
      jQuery('#dragForm').css('opacity', 1)
      e.stopPropagation()
    },

    dragLeave: function (data, e) {
      jQuery('#dragForm').css('visibility', 'hidden')
      jQuery('#dragForm').css('opacity', 0)
      e.stopPropagation()
    },

    dropFiles: function (data, e) {
      // jQuery('#dragForm').css('visibility', 'hidden')
      // jQuery('#dragForm').css('opacity', 0)
      var processFile = (files, path) => {
        if (this.isFileUploading) {
          this.dragFilesQueue.push({folder: path, files: files, currentFolder: this.currentFolder})
        }
        else {
          this.uploadFolder = path
          jQuery('#uploadFile').prop('files', files)
          this.isFileUploading = true
          this.startUpload(this.currentFolder)
        }
      }
      var addDirectory = (item, path) => {
        // console.log('addDirecory', item)
        if (item.isDirectory) {
          var directoryReader = item.createReader()
          directoryReader.readEntries(function (entries) {
            entries.forEach(function (entry) {
              addDirectory(entry, path === '' ? item.name : path + '/' + item.name)
            })
          })
        }
        else {
          item.file(function (file) {
            let list = new DataTransfer()
            list.items.add(file)
            processFile(list.files, path)
          })
        }
      }
      // if directory support is available
      if (e.dataTransfer && e.dataTransfer.items) {
        var items = e.dataTransfer.items
        for (var i = 0; i < items.length; i++) {
          var item = items[i].webkitGetAsEntry()
          if (item) {
            addDirectory(item, '')
          }
        }
      }
      else {
        // Fallback
        var files = e.target.files || e.dataTransfer.files
        if (files.length) {
          processFile(files, '')
        }
      }
    },

    formatMem: function (bytes, sep) {
      if (typeof bytes === 'string' || bytes instanceof String) bytes = parseInt(bytes)
      var i = 0
      while (bytes >= 1024) { bytes = Math.round(bytes / 1024); i++ }
      var mes = ['B', 'KB', 'MB', 'GB', 'TB']
      return bytes + sep + mes[i]
    },

    deleteFiles: function () {
      var checkedFiles = []
      var forConfirmMessage = ''
      for (let i = 0; i < this.files.length; i++) {
        if (this.files[i].checked) {
          var f = this.currentFolder + '/' + this.files[i].name
          if (this.currentFolder === this.homeFolder && this.virtualFoldersNames.includes(this.files[i].name)) continue
          checkedFiles.push(f)
          if (forConfirmMessage.length < 100) {
            if (forConfirmMessage !== '') forConfirmMessage += ', '
            forConfirmMessage += this.files[i].name
          }
          else if (forConfirmMessage.substr(forConfirmMessage.length - 3) !== '...') forConfirmMessage += ', ...'
        }
      }
      if (checkedFiles.length > 0) {
        this.confirm.title = 'Подтвердите удаление'
        this.confirm.message = 'Вы действительно хотите удалить файлы: ' + forConfirmMessage
        this.confirm.okTitle = 'Да'
        this.confirm.closeTitle = 'Нет'
        var th = this
        this.confirm.actionOk = () => {
          runServiceCommand('cmd=DELETE_FILES&checkedFiles=' + encodeURIComponent(JSON.stringify(checkedFiles))).then((res) => {
            if ('stack' in res) th.showError(res.message)
            else
              if (res['result'] !== 'OK') th.showError(res['result'])
              else {
                th.selectAllValue = false
                th.showInfo('Файлы были удалены')
              }
            th.changeDir(th.currentFolder, false)
          }).catch(e => th.showError(e))
        }
        this.$refs.confirmDialogRef.show()
      }
      else this.showError('Выделите файлы')
    },

    selectAll: function (checked) {
      for (let i = 0; i < this.files.length; i++) this.files[i].checked = checked
    },

    exitFolder: function () {
      if (this.currentFolder === '/') return
      var i = this.currentFolder.lastIndexOf('/')
      if (i < 0) return
      var newFolder = i === 0 ? '/' : this.currentFolder.substr(0, i)
      if (this.virtualFolders.includes(this.currentFolder)) newFolder = this.homeFolder
      this.changeDir(newFolder, true)
    },

    contactSupport: function () {
      var mes = this.contactSupportMessage
      mes = mes + '\nUser: ' + this.currentUserName + ' group=' + this.group + ' type=' + this.studentType + '\n'
      mes += 'Folder: ' + this.currentFolder
      runServiceCommand('cmd=CONTACT_SUPPORT&message=' + encodeURIComponent(mes)).then((res) => {
        if ('stack' in res) this.showError(res.message)
        else this.showInfo('Ваше сообщение успешно отправлено в службу поддержки')
      }).catch(e => this.showError(e))
    },

    changePass: function () {
      if (this.password1 === this.password2 && this.password2 !== '') {
        this.$refs.changePassRef.hide(true)
        var authType = '&authType=' + this.authType
        var studentType = '&studentType=' + this.studentType
        var course = '&course=' + this.course
        var group = '&group=' + this.group
        var FIO = '&FIO=' + this.currentUserName
        var password = '&password=' + this.password1
        // alert(this.studentType)
        runServiceCommand('cmd=CHANGE_PASS' + authType + studentType + course + group + FIO + password).then((res) => {
          // if ('stack' in res) this.showError(res.message)
          // else this.showInfo('Ваше сообщение успешно отправлено в службу поддержки')
        }).catch(e => this.showError(e))
        // this.$refs.changePass.hide(true)
      }
    },

    sort: function (files, sortType) {
      if (this.homeFolder === this.currentFolder) {
        files = files.slice(1)
      }
      switch (sortType) {
        case 'names':
          files.sort((f1, f2) => {
            return (-(f1.isDir > f2.isDir) + (f2.isDir > f1.isDir)) * 100 - this.sortType[0] * (f1.name.toLowerCase() > f2.name.toLowerCase()) + this.sortType[0] * (f2.name.toLowerCase() > f1.name.toLowerCase())
          })
          this.sortType[0] *= -1
          this.whatSort = 0
          break
        case 'sizes':
          files.sort((f1, f2) => {
            return (-(f1.isDir > f2.isDir) + (f2.isDir > f1.isDir)) * 100 + this.sortType[1] * (f1.size > f2.size) - this.sortType[1] * (f2.size > f1.size)
          })
          this.sortType[1] *= -1
          this.whatSort = 1
          break
        case 'dates':
          files.sort((f1, f2) => {
            return (-(f1.isDir > f2.isDir) + (f2.isDir > f1.isDir)) * 100 + this.sortType[2] * (f1.date > f2.date) - this.sortType[2] * (f2.date > f1.date)
          })
          this.sortType[2] *= -1
          this.whatSort = 2
          break
      }
      if (this.homeFolder === this.currentFolder) {
        files.unshift(this.files[0])
        this.files = files
      }
    },
    loadFIOList: function () {
      let context = this
      setTimeout(() => {
        var authType = '&authType=schoolkid'
        var group = '&group=' + context.selectedGroup
        runServiceCommand('cmd=GET_FIO_LIST' + authType + group).then((FIOList) => {
          context.FIOList.splice(1)
          context.FIOList = context.FIOList.concat(FIOList)
        }).catch(e => context.showError(e))
      })
    },
    erasePass: function () {
      this.$refs.erasePassRef.hide(true)
      var authType = '&authType=' + 'schoolkid'
      var studentType = '&studentType=' + this.studentType
      var course = '&course=' + this.course
      var group = '&group=' + this.selectedGroup
      var FIO = '&FIO=' + this.selectedStudentFIOList
      runServiceCommand('cmd=ERASE_PASS' + authType + studentType + course + group + FIO).then((res) => {
        // if ('stack' in res) this.showError(res.message)
        // else this.showInfo('Ваше сообщение успешно отправлено в службу поддержки')
      }).catch(e => this.showError(e))
      // this.$refs.changePass.hide(true)
    }
  }
}
</script>

<style scoped>
@font-face { font-family: nanoFont; src: url(./../assets/nano.ttf); }
.navbar-brand { font-family: nanoFont; color:#000!important; text-shadow: 2px 2px 1px rgba(0,0,0,0.5); }
body { font-size:12pt; min-width:320px; height:100%;}
body.modal-open { overflow: visible; }
a { color:#68705e!important; }
nav.bg-success { background-color: #e6f9cf !important;}

.nav {align-items: center;}
.navbar { margin-bottom: 0; border-radius: 0;}
.navbar-inverse { background-color: #e6f9cf; border-color: #080808; }
.navbar-toggler { border-color: #000!important; background-color: #68705e; cursor:pointer; }
/* .navbar-toggler:hover { background-color: transparent; } */
.navbar-inverse .navbar-nav .nav-link {color: #000!important; cursor: pointer;}

/* a.nav-link:hover { color: #fff!important; } */
/* .nav > li:hover { background-color: #68705e; color:#000;} */
/* .nav > li:hover > a.nav-link { color: #fff!important; } */
/* .navbar-brand:hover { color:#000!important; } */

.main-page-content {max-width: 1024px; padding:10px 0 0 0; border-bottom-style: solid; border-bottom-width: 1px; border-bottom-color: rgba(0,0,0,0.1); text-align: center; width: 100%; }
.main-page-content > div {vertical-align:middle;}

div.alertsBlock { position:fixed; top:60px; left:0; width:100%; z-index:2000; text-align:center;}
.alert { display:inline-block; }

fieldset { border: 1px groove silver !important; }
fieldset legend { text-align: left; margin-left: 20px; width: inherit; font-size: inherit; }
legend .custom-control { padding-left: 0; margin-right:0; }
label { display:inline-block!important; }

#toolbar-container {margin:0 auto;}
.toolbar { z-index: 1; }
.toolbar > div { display:inline; }
.toolbar button.btn-primary { background-color:#e6f9cf; margin:0px 0px; border-color:#68705e; border-width:0px; }
.toolbar button.btn-primary > img { height:30px; }
.toolbar button.btn-primary:hover { background-color:#fff; }
.toolbar button.btn-primary:focus { box-shadow: none; }
.toolbar button.btn-primary:active { box-shadow: 0 0 0 2px rgba(104,112,94,.5); }
.popover-content-wrapper { text-align:center; }
.fixed { position: fixed; top: 0px; }
#uploadButtonSpan { text-align:center; width:30px; height:30px; background-image:url("./../assets/upload.png"); background-size:cover;  }
#uploadProgress { line-height: 50px; color:#000; position: relative; top: 12px; }
@media only screen and (max-width: 516px) {
  .toolbar button.btn-primary img { width:40px; }
  #uploadButtonSpan { width:40px; height:40px; }
  .btn { padding:4px; }
}

.breadcrumbs { text-align: left; font-size: 16px; padding:0 30px; font-weight:bold; margin: 15px 0 0 0; }
.breadcrumb {padding: 5px 20px; background-color: #e6f9cf; }

.row {margin:0px 0px 0px 0px;}
.row.content { height:auto; }
.files .row { display:block; }
.empty-row {height: 80px; line-height: 80px}
.file .btn { background-color:transparent; font-size: 14px; vertical-align: middle; padding: 0px 6px; color:#000; border-width:0; }
.btn.active, .btn:hover { background-color:#e6f9cf; }
.header { font-weight:bold; background-image: none;}

.exitFolderButton { padding: 5px 10px!important; }
.file { margin-left: 0px; font-size: 16px; border-top-style: solid; border-top-width: 1px; border-top-color: rgba(0,0,0,0.1); height: 50px; line-height: 50px; background-image: url(./../assets/file-icon.png); background-repeat: no-repeat; background-position: 40px 13px; text-align: left; padding-left: 10px;}
.file:hover {background-color: #e6f9cf}
.file.header:hover {background-color: transparent; }
.file > div {display: inline-block; vertical-align: middle; overflow-x: auto; white-space:nowrap;}
.file .custom-checkbox { margin:0;  padding: 0; width:15px; }
.file label {width:15px; display: inline-block!important; top:5px;}
.file.header .file-col-name label { display: inline!important; top:0px;}

.file-col-name { width: calc(100% - 347px); text-align: left; overflow-x: auto; padding-left: 40px; }
.file.header .file-col-name { padding-left: 0px; width: calc(100% - 308px); overflow-x: hidden; }
.file-col-name .custom-control { margin-right:0; padding-left: 1.2rem;  }
.file-col-actions { width: 88px; text-align: center; }
.file-col-actions button.btn.btn-primary { padding: 0px 3px; }
.file-col-actions button.btn.btn-primary:focus { box-shadow: none; }
.file-col-actions button.btn.btn-primary:active { box-shadow: 0 0 0 2px rgba(104,112,94,.5); }
.file-col-size {width: 85px; text-align: left; overflow-x: auto; }
.file-col-date {width: 130px; text-align: left; overflow-x: auto; }
.file.header > div {text-align: center;}

@media only screen and (max-width: 516px) {
  div.file-col-size { display: none; }
  div.file-col-date { display: none; }
  .file-col-name { width: calc(100% - 160px); }
  .file.header .file-col-name { width: calc(100% - 113px); }
}

a.nav-link { color:#000; }
.directory { user-select: none; -webkit-user-select: none; -moz-user-select: none; -ms-user-select: none; background-image: url(./../assets/directory-icon.png); cursor:pointer; }
.header { font-weight:bold; background-image: none;}
.file {cursor:pointer;}
.form-control:focus { border-color: #68705e;}
.checked {background-color: #eee;}

footer { background-color: #e6f9cf; color: black; padding: 15px; text-align: center; }
footer.modal-footer { background-color: transparent; }
.modal-footer .btn-primary:hover { background-color: #e6f9cf; }
.btn-secondary:focus { box-shadow: none; }
footer img {float:none; width:40px; height: 40px; margin-right: 10px;}

#viewText {height: 100%;}
#viewText .modal-dialog.modal-md {height: calc(100% - 60px);}
#viewText .modal-content {height: 100%; overflow-y: auto;}
#viewText_modal_body { text-align: left; font-size: 16px; margin-left: 3%; margin-right: 3%; overflow: auto; height: calc(100% - 50px);}
#viewText_modal_body.modal-body { margin: 0 0; }
#viewText .modal-header { padding: 5px 15px; margin: 5px 5px;}

 @media (min-width: 576px) {
  #viewText .modal-dialog { max-width: inherit; margin: 30px 10%; overflow-x: auto;}
}
</style>

<style>
.navbar-toggleable-sm {z-index: 999;}
.navbar-inverse .navbar-nav .nav-link {color:#000; cursor: pointer;}
.navbar-inverse .navbar-nav .nav-link:hover {color: #000;}
.custom-control { margin-right:1rem; padding-left: 1.2rem; }
.custom-control-input:checked~.custom-control-indicator { background-color: #68705e; }
.custom-control-input:focus~.custom-control-indicator { box-shadow: 0 0 0 1px #fff,0 0 0 3px #68705e; }
.breadcrumb-item a { cursor:pointer; }
.custom-select { width:100%; }
</style>



// WEBPACK FOOTER //
// MainPage.vue?7072439e